import { render, staticRenderFns } from "./MoleculeBuildingOrientationBar.vue?vue&type=template&id=6d694610&"
import script from "./MoleculeBuildingOrientationBar.vue?vue&type=script&lang=js&"
export * from "./MoleculeBuildingOrientationBar.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeBuildingOrientationBar.vue?vue&type=style&index=0&id=6d694610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeBuildingOrientationBar.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2FMoleculeBuildingOrientationBar.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomInfoPopup: require('/app/components/atoms/common/AtomInfoPopup.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomInfoPrice: require('/app/components/atoms/common/AtomInfoPrice.vue').default,MoleculesProjectMoleculeFitoutSelector: require('/app/components/molecules/project/MoleculeFitoutSelector.vue').default})
